import React, { memo } from 'react';
import {
    TextField,
    InputAdornment,
    InputBaseComponentProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { parseNumericInput } from 'helpers/UIHelpers';
import NumberFormatCustom from 'components/NumberFormat/NumberFormatCustom';

const StyTextField = styled(TextField)(() => ({
    '& .MuiInputBase-root': {
        backgroundColor: 'white',
    },
    '& .MuiInputBase-input': {
        fontSize: '12px',
        padding: '12px 14px',
    },
    '& .Mui-disabled': {
        color: 'black', // text color
        backgroundColor: 'transparent',
        fontSize: '12px',
    },
    width: '100%',
}));

const percentAdornment = (
    <InputAdornment sx={{ backgroundColor: 'white' }} position="start">
        %
    </InputAdornment>
);

const HypothesisValueInput = ({
    type,
    disabled = false,
    value,
    handleInputChange,
    inputProps,
}: {
    type: 'percentage' | 'number' | 'date';
    disabled?: boolean;
    value: number | string | undefined;
    handleInputChange?: (newValue: number | string) => void;
    inputProps?: InputBaseComponentProps;
}): React.ReactElement => {
    const isNumeric = ['percentage', 'number'].includes(type);
    const defaultValue = isNumeric ? 0 : '';
    const inputComponent = isNumeric ? NumberFormatCustom : undefined;
    const startAdornment = type === 'percentage' ? percentAdornment : undefined;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (isNumeric) {
            const newValue = parseNumericInput(e.target.value);
            handleInputChange?.(newValue);
        } else {
            handleInputChange?.(e.target.value);
        }
    };

    return (
        <StyTextField
            disabled={disabled}
            onFocus={(e) => {
                e.target.select();
            }}
            type={type === 'date' ? 'date' : undefined}
            value={value ?? defaultValue}
            onChange={onChange}
            inputProps={inputProps}
            InputProps={{
                inputComponent,
                startAdornment,
            }}
        />
    );
};

export default memo(HypothesisValueInput);
